import HomeCard from "./homeCard";
import PopUpFormSponsor from "../../../popUpForms/popUpFormSponsor";

const CardSponsorOpportunities = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="sponsor"
      title="Sponsor Opportunities"
      titleColor="var(--green)"
      image="./images/home/card-sponsor-opportunities.jpg"
      popUpComponent={<PopUpFormSponsor />}
      content={[
        {
          type: "header-H4",
          text: "Elevate your Venture, Drive Innovation, and Build Resilience",
          color: "var(--green)",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "CWPC's sponsorship package offers unparalleled opportunities to increase brand visibility, connect with industry leaders, and make a lasting impact on social responsibility initiatives, community safety, and regeneration.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "By participating in CWPCs sponsorship packages, you become an integral part of a movement dedicated to fostering innovation across industries.",
        },
        { type: "button", text: "Explore Sponsorship", color: "var(--green)" },
      ]}
    />
  );
};

export default CardSponsorOpportunities;
